export default {
  loading: 'Carregando...',
  noItemsFound: 'Nenhum item encontrado',
  itemsWillAppear: 'Os itens aparecerão aqui quando estiverem disponíveis',
  page: 'Página'
}
